if (!window.customElements.get('custom-sticky-static')) {
  window.customElements.define(
    'custom-sticky-static',
    class CustomStickyStatic extends HTMLElement {
      connectedCallback() {
        this.initDOMElements();
        this.initVisibilityObserver();
        this.handleScrollToTrigger();
        this.initOfferSummary();
      }

      disconnectedCallback() {
        this.removeVisibilityObserver();
        this.offer?.removeEventListener('offer:change', this.onOfferChange);

        if (this.scrollToTrigger && this.boundHandleTriggerClick) {
          this.scrollToTrigger.removeEventListener('click', this.boundHandleTriggerClick);
        }
      }

      initOfferSummary() {
        const summary = this.querySelector('.custom-sticky-static__selection');
        this.offer = summary && this.scrollToSelector?.closest('custom-refund-offer');
        if (!this.offer) return;
        this.onOfferChange = ({ detail }) => {
          this.querySelector('[data-sticky-plan]').textContent = detail.months + (detail.months === '1' ? ' month' : ' months');
          this.querySelector('[data-sticky-price]').textContent = '$' + detail.price;
          const compare = this.querySelector('[data-sticky-compare]');
          compare.textContent = '$' + detail.compare;
          compare.hidden = Number(detail.compare) <= Number(detail.price);
          summary.hidden = false;
        };
        this.offer.addEventListener('offer:change', this.onOfferChange);
        const selected = this.offer.querySelector('[data-tier][aria-pressed="true"]');
        const purchase = this.offer.querySelector('[data-purchase][aria-pressed="true"]');
        if (selected && purchase) {
          this.onOfferChange({ detail: { months: selected.dataset.months, price: selected.dataset[purchase.dataset.purchase + 'Price'], compare: selected.dataset.compare } });
        }
      }

      initDOMElements() {
        this.scrollToTrigger = this.querySelector('#scroll-to-trigger');
        this.observerSelector = document.querySelector(this.dataset.observerSelector);
        this.scrollToSelector = document.querySelector(this.dataset.scrollToSelector);
        this.checkoutUrl = this.dataset.checkoutUrl || null;
        this.openInNewTab = this.dataset.openNewTab === 'true';
        this.enableGtmTracking = this.dataset.enableGtmTracking === 'true';
      }

      initVisibilityObserver() {
        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.add('hidden');
              } else {
                const observerRect = this.observerSelector.getBoundingClientRect();
                if (observerRect.top < 0) {
                  this.classList.remove('hidden');
                }
              }
            });
          },
          {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px',
          },
        );

        if (this.observerSelector) {
          this.visibilityObserver.observe(this.observerSelector);
        }
      }

      removeVisibilityObserver() {
        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }
      }

      handleScrollToTrigger() {
        if (!this.scrollToTrigger) {
          return;
        }

        this.boundHandleTriggerClick = () => {
          const url = this.appendTrackingParams(this.dataset.url);

          if (url) {
            if (this.openInNewTab) {
              window.open(url, '_blank', 'noopener');
            } else {
              window.location.href = url;
            }
          } else if (this.scrollToSelector) {
            this.scrollToSelector.scrollIntoView({ behavior: 'smooth' });
          }
        };

        this.scrollToTrigger.addEventListener('click', this.boundHandleTriggerClick);
      }

      appendTrackingParams(url) {
        if (!this.enableGtmTracking || !url || !window.SeranovaTracking) {
          return url;
        }

        return window.SeranovaTracking.appendParams(url);
      }
    },
  );
}
